import { POSITIONS } from './constants.js';

const order = (pos) => {
  const i = POSITIONS.indexOf(pos);
  return i === -1 ? 99 : i;
};

/**
 * Formats a split as plain text for pasting into a group chat.
 *
 * However good the app is, the teams reach people through WhatsApp. Making that
 * one tap rather than a screenshot is worth more than most features.
 */
export function teamsAsText({ teamA, teamB, groupName, date = null }) {
  const side = (label, team) => {
    const avg = team.reduce((s, p) => s + (p._rating ?? 0), 0) / (team.length || 1);
    const rows = [...team]
      .sort((x, y) => order(x.assignedPosition) - order(y.assignedPosition))
      .map((p) => `${(p.assignedPosition || '').padEnd(3)} ${p.name}`);
    return [`${label} — ${avg.toFixed(1)} avg`, ...rows].join('\n');
  };

  const header = [groupName, date ? new Date(date).toLocaleDateString(undefined, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  }) : null]
    .filter(Boolean)
    .join(' — ');

  return [header, '', side('TEAM A', teamA), '', side('TEAM B', teamB)].filter((x) => x !== null).join('\n');
}

/**
 * Clipboard access needs a secure context and can be blocked outright, so this
 * falls back to a hidden textarea rather than failing silently.
 */
export async function copyText(text) {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    /* fall through */
  }

  try {
    const el = document.createElement('textarea');
    el.value = text;
    el.setAttribute('readonly', '');
    el.style.position = 'fixed';
    el.style.opacity = '0';
    document.body.appendChild(el);
    el.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(el);
    return ok;
  } catch {
    return false;
  }
}
